import AnnouncementTypeEnum from 'common/constants/AnnouncementTypeEnum';
import UserAnnouncementStatusTypeEnum from 'common/constants/UserAnnouncementStatusTypeEnum';
import { useLingui } from '@lingui/react';
import { t } from '@lingui/macro';
import { applyTimeZone, formattedDate } from 'utils/formattedtimeZonesAdapter';
import { Dot, FlagFilledIcon, ListItem, ListItemActions, ListItemContent, ListItemIcon, ListItemSubtitle, ListItemTitle, Tooltip, Typography, } from '@onsolve/onsolve-ui-components';
import React from 'react';
import styles from './AnnouncementsListRow.module.scss';
import AnnouncementTypeIconLookup from './AnnouncementTypeIconLookup/AnnouncementTypeIconLookup';
import { AnnouncementTypesLookup } from './AnnouncementTypesLookup/AnnouncementTypesLookup';
const AnnouncementsListRow = ({ onClick, userTimeZone = {}, dataItem: { type = AnnouncementTypeEnum.MAINTENANCE, htmlBody = '', subject = '', createdDate = '', isUrgent = true, status, }, }) => {
    const isUnread = status === UserAnnouncementStatusTypeEnum.UNREAD;
    const { i18n } = useLingui();
    return (<div className={styles.list}>
            <ListItem onClick={onClick}>
                {isUnread && (<span aria-label="Unread Icon">
                        <ListItemIcon>
                            <Typography variant="p14">
                                <Dot color="catalina-blue"/>
                            </Typography>
                        </ListItemIcon>
                    </span>)}
                <ListItemContent className={isUnread ? `${styles.list_text_unread}` : `${styles.list_text}`}>
                    <ListItemTitle className={isUnread ? `${styles.unreadTitle}` : ''} color={isUnread ? 'primary' : 'secondary'} text={subject}/>
                    <ListItemSubtitle className={styles.list_body} color={isUnread ? 'secondary' : 'initial'} text={htmlBody.replace(/<[^>]*>/g, '')}/>
                </ListItemContent>
                <ListItemActions className={styles.list_info}>
                    <Typography className={styles.list_date} color="secondary" variant="p10">
                        {formattedDate(applyTimeZone(createdDate, userTimeZone))}
                    </Typography>
                    <span>
                        {isUrgent && (<Tooltip title={t `Urgent`}>
                                <span>
                                    <FlagFilledIcon aria-label="Urgent Icon" className={styles.list_flagIcon}/>
                                </span>
                            </Tooltip>)}
                        <Tooltip title={i18n._(AnnouncementTypesLookup[type.toLowerCase()].title)}>
                            <span>
                                <AnnouncementTypeIconLookup type={type}/>
                            </span>
                        </Tooltip>
                    </span>
                </ListItemActions>
            </ListItem>
        </div>);
};
export default AnnouncementsListRow;
